import { Route, Routes } from "react-router-dom";
import Home from "./routes/Home";
import Navbar from "./components/Navbar";
import Lenis from "@studio-freight/lenis";
import { useEffect } from "react";
import Footer from "./components/homeComponents/Footer";
import Schulungen from "./routes/Schulugen";
import Contact from "./components/homeComponents/Contact";
import AboutMe from "./routes/AboutMe";
import Benefits from "./routes/Benefits";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2, // scroll smoothness (higher = smoother)
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // buttery easing
      smoothWheel: true,
      smoothTouch: false, // usually false for mobile
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/schulungen" element={<Schulungen />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/leistungen" element={<Benefits />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
